<template>
	<div class="recruiters">
		<div v-if="is_loading" class="loading" style="margin-left: 10px;"></div>
		<div v-for="recruiter in recruiters" class="recruiter">
			<p @click="openRecruiteFeeModal(recruiter)">
				<u>{{ recruiter.recruiter_name }}</u>
			</p>
			<a @click="deleteRecruiter(recruiter)" class="button is-danger">X</a>
		</div>
		<a @click="createNewRecruiterFee" class="add_recruiter_fee button is-info" :class="{ margin_right_0: recruiters.length == 0 }">
			Add Recruiter Fee
		</a>
	</div>
</template>
<script>
	import { mapMutations } from 'vuex'
	export default {
		name: 'offer-recruiters',
		props: ['payload'],
		data(){
			return {
				is_loading: false,
				recruiters: []
			}
		},
		created(){
			this.getRecruiters()
		},
		methods: {
			getRecruiters(){
				this.is_loading = true
				this.recruiters = []
				this.$network_utils.getRecruiterFees({ offer_id: this.payload.id }).then(response => {
					this.recruiters = response
					this.is_loading = false
				})
			},
			openRecruiteFeeModal(recruiter){
				this.createModal({
					component_name: 'RecruiterFeeForm',
					modal_title: recruiter.recruiter_name,
					offer: this.payload,
					data: recruiter,
					callback: () => this.getRecruiters()
				})
			},
			createNewRecruiterFee(){
				this.createModal({
					component_name: 'RecruiterFeeForm',
					modal_title: 'Create New Recruiter',
					offer: this.payload,
					is_create: true,
					callback: () => this.getRecruiters()
				})
			},
			deleteRecruiter(recruiter){
				this.$network_utils.deleteRecruiterFee({ id: recruiter.id }).then(response => {
					this.getRecruiters()
				})
			},
			...mapMutations('modals', ['createModal'])
		}
	}
</script>
<style scoped>
	.recruiters {
		display: flex;
		align-items: center;
		margin-top: 10px;
	}
	.recruiter {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 5px 10px;
		border-radius: 4px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		cursor: pointer;
		font-size: 15px;
		margin: 0;
		margin-left: 6px;
	}
	.recruiter a {
		margin-right: 5px;
		font-size: 10px;
	}
	.add_recruiter_fee {
		margin-right: 3px;
		font-size: 10px;
	}
</style>